import * as React from "react";
import INavigationMenuProps from "./INavigationMenu";
import { bindActionCreators } from "redux";
import ChevronUp from "../../../assets/images/chevron-up-thick-red.png";
import ChevronDown from "../../../assets/images/chevron-down-thick-red.png";
import "../../../assets/sass/widgets/navigationMenu.scss";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import * as globalActionsCreator from "../../globalStore/actions";
import { connect } from "react-redux";
import { dateTimeFormatter, getSessionValue, handleEnter, setSessionValue } from "../../utils//utils";
import GAFContact from "../GAFContact";
import ReactGA from "react-ga";
import AlertMessage from "../AlertMessageWidget";
import ReviewErrorsPopup from "../../components/ReviewErrorsPopup";

import { errorCalculator, getFirstError, getLastIdSubstring, skipAdminValidation, getFormattedErrors, imagePathurl } from "../../utils/utils";
import { WARRANTY_ERROR_CHECK } from "../../constants/storageKeys";
interface INavigationMenuStateProps {
    menuVisible: boolean;
    showPDCount: boolean;
    menuKeys: any;
    errors?: any;
    clickedGoToError?: boolean;
}

/**
 * @class NavigationMenu
 * @category Widgets
 * @description  to display the navigation menu showing in the left panel of the form , this takes care of  validation , error count display and the storing the form values to the redux store
 */
class NavigationMenu extends React.Component<INavigationMenuProps, INavigationMenuStateProps, {}> {
    constructor(props) {
        super(props);
        this.state = {
            menuVisible: false,
            menuKeys: this.props.menuKeys,
            showPDCount: false,
            clickedGoToError: false,
            errors: [],
        };
    }
    componentDidMount() {
        this.setNavMenus();
        if (!this.props.value) {
            this.props.onChange(
                this.props.schema.default ? this.props.schema.default : this.props.schema.anyOf[0].enum[0]
            );
        }
        this.handlePositionSticky();
        if (this.props.paymentsInfo.isAlreadyPaymentInitiated || this.props.isSubmittedForm) {
            this.props.dynamicFormActions.updateFormType(true);
        }
        if (getSessionValue(WARRANTY_ERROR_CHECK)){
            setSessionValue(WARRANTY_ERROR_CHECK, "");
            this.setState({
                errors: getFormattedErrors(this.props.errorDetails, this.props.uiSchema, this.props.userInfo.isAdmin),
            });
        }
        const currentOption =
            this.props.formData.residentialWarrantyForm && this.props.formData.residentialWarrantyForm.NavigationMenu;
        if (currentOption) setTimeout(() => this.focusErrorElement(currentOption), 1000);
    }

    goToError = () => {
        const errors = Object.keys(this.props.errorDetails);
        let currentOption = "PD";
        if (errors.some((error) => error.includes("buildingAndOwnerInfo"))){
            this.handleClick("BO", `${this.props.id}-0`);
            currentOption = "BO";
            this.setState({
                clickedGoToError: true,
            });
        }
        setTimeout(() => {
            this.hideReviewErrorsPopup();
            this.focusErrorElement(currentOption);
        }, 1000);
    };

    componentDidUpdate(prevProps, nextState) {
        this.setNavMenus();
        const currentNavMenu =
            this.props.formData.residentialWarrantyForm && this.props.formData.residentialWarrantyForm.NavigationMenu;
        const prevNavMenu =
            prevProps.formData.residentialWarrantyForm && prevProps.formData.residentialWarrantyForm.NavigationMenu;
        if (currentNavMenu !== prevNavMenu) {
            let arr = [];
            const test = this.state.menuKeys.map((menu) => {
                if (menu[currentNavMenu]) {
                    menu.visitCount = menu.visitCount + 1;
                }
                if (menu[prevNavMenu]) {
                    menu.visitCount = menu.visitCount + 1;
                }
                if (currentNavMenu === "RP") {
                    menu.visitCount = menu.visitCount + 2;
                }
                return menu;
            });
            arr = test;
            this.setState({ menuKeys: arr }, () => {
                if (!this.props.isSavedDraft && arr[1].visitCount == 1) {
                    const errorDetails =
                        this.props.errorDetails &&
                        Object.keys(this.props.errorDetails).length &&
                        JSON.parse(JSON.stringify(this.props.errorDetails));
                    if (errorDetails) {
                        for (const key in errorDetails) {
                            if (key.indexOf("projectDetails") > -1 && !this.props.isDraft) {
                                delete errorDetails[key];
                            }
                        }
                        const payload = {
                            errors: {
                                formValidationSummary: errorDetails,
                            },
                        };
                        this.props.dynamicFormActions.fetchFormErrorResponseSuccess(payload);
                    }
                }
                this.props.dynamicFormActions.addTabDetailsToStore(arr);
                this.props.dynamicFormActions.navigationClickDetails({});
            });
            if (this.state.clickedGoToError){
                this.setState({ clickedGoToError: false });
                setTimeout(() => this.focusErrorElement(currentNavMenu), 3000);
            }
        }
    }
    setNavMenus = () => {
        if (!this.props.navMenus || !this.props.navMenus.length) {
            const navMenus = [];
            this.props.options.enumOptions.map((item, index) => {
                navMenus.push({ menu: item, id: this.props.id + "-" + index });
            });
            this.props.dynamicFormActions.addNavMenusToStore(navMenus);
        }
    };
    // click event
    handleClick(option, id) {
        {
            this.props.isApiCallInProcess && this.props.dynamicFormActions.navigationClickDetails({ clickId: id });
        }
        const {
            formData,
            formId,
            warrantyId,
            saveMobileMsg,
            isApiCallInProcess,
            saveDesktopMsg,
            errorDetails,
            uiSchema,
        } = this.props;
        setTimeout(() => this.focusErrorElement(option), 1005);
        const {
            mergeFormDatatoStore,
            saveDraftFormSuccess,
            updateNavigationMenuStatus,
            validateBuildingAddress,
        } = this.props.dynamicFormActions;
        const successCallBackUpdate = () => {
            this.props.dynamicFormActions.fetchSavedFormDataSuccess({
                value: { id: this.props.warrantyId, updateNavigation: option },
            });
        };
        // Removing flag for Admin flow when navigating from left side menu
        if (sessionStorage.getItem('continueAsAdminForError') && option !== "RP") {
            sessionStorage.removeItem('continueAsAdminForError');
        }
        // Removing isVarianceRequested entry on navigation
        if (sessionStorage.getItem('isVarianceRequested') && option !== "RP") {
            sessionStorage.removeItem('isVarianceRequested');
        }
       
        const successCallBack = (errors) => {
            if (
                option === "RP" &&
                errors &&
                Object.keys(errors).length &&
                !skipAdminValidation(errors, this.props.userInfo.isAdmin)
            ) {
                this.setState({
                    errors: getFormattedErrors(errors, uiSchema, this.props.userInfo.isAdmin),
                });
                return;
            }
            mergeFormDatatoStore({
                payload: {
                    id: warrantyId ? warrantyId : formId,
                    formData: formData,
                    updateNavigation: option,
                    successCallBack: successCallBackUpdate,
                },
            });
        };
        const validateBillingAddreCbk = (status) => {
            updateNavigationMenuStatus(status);
            if (status) {
                if (this.props.menuKeys[1] && this.props.menuKeys[1].visitCount >= 1) {
                    this.setState({ showPDCount: true });
                }
                this.props.dynamicFormActions.getErrorResponseOnNavChange({
                    id: warrantyId ? warrantyId : formId,
                    successCallBack,
                });
            } else {
                this.props.dynamicFormActions.getErrorResponseOnNavChange({ id: warrantyId ? warrantyId : formId });
                //updateBillingAddressStatus({ payload: status });
                if (!saveDesktopMsg || !saveMobileMsg) {
                    saveDraftFormSuccess({ payload: "Unable to save" });
                }
            }
        };
        !isApiCallInProcess && validateBuildingAddress({ successCallback: validateBillingAddreCbk });
    }
    focusErrorElement = (option) => {
        const {
            formData: { residentialWarrantyForm },
            errorDetails,
            menuKeys,
            uiSchema,
        } = this.props;
        const currMenu = (residentialWarrantyForm && residentialWarrantyForm.NavigationMenu) || option;
        try {
            // if (menuKeys.findIndex((menu) => !!menu[option]) >= menuKeys.findIndex((menu) => !!menu[currMenu])) {
            if (errorDetails && Object.keys(this.props.errorDetails).length) {
                const currentPage = menuKeys.find((key) => key[currMenu])[currMenu];
                const id = getFirstError(errorDetails, currentPage, uiSchema);
                const elmnt: any =
                    document.getElementById(id) ||
                    document.getElementById(id + "-0") ||
                    document.getElementById(getLastIdSubstring(id, uiSchema) + "-0");
                if (elmnt && elmnt.offsetTop) {
                    window.scroll(0, elmnt.offsetTop || 0);
                    elmnt.focus();
                    return true;
                } else if (elmnt && elmnt.offsetTop === 0) {
                    elmnt.scrollIntoView({ block: "center", inline: "nearest" });
                }
            }
            // }
        } catch (err) {
            console.log(err);
        }
        return false;
    };
    navCounter = (enumOption) => {
        if (this.props.menuKeys) {
            switch (enumOption) {
                case "BO": {
                    return errorCalculator(this.props.menuKeys, enumOption, this.props.errorDetails)[
                        "buildingAndOwnerInfo"
                    ];
                }
                case "PD": {
                    return errorCalculator(this.props.menuKeys, enumOption, this.props.errorDetails)["projectDetails"];
                }
                case "RP": {
                    return errorCalculator(this.props.menuKeys, enumOption, this.props.errorDetails)["reviewAndPay"];
                }
                default:
                    return 0;
            }
        } else return 0;
    };

    addSticky() {
        const nav = document.querySelector(".NavigationMenu");
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
        );
        const windowBottom = windowHeight + window.pageYOffset;
        if (nav && nav.classList) {
            if (windowBottom >= docHeight - 100) {
                nav.classList.remove("addsticky");
                nav.classList.add("removepossticky");
            } else {
                nav.classList.remove("removepossticky");
            }
        }
    }

    handlePositionSticky() {
        const nav = document.querySelector(".NavigationMenu");
        const offset = (nav && nav.getBoundingClientRect()) || "";
        const offsetAddition =
            this.props.userInfo && (this.props.userInfo.isAdmin || this.props.userInfo.isTm) ? 165 : 130;
        window.addEventListener("scroll", () => {
            // +130 is Navigation padding-top in px
            if (nav && nav.classList) {
                if (offset && window.pageYOffset + offsetAddition >= offset.top) {
                    nav.classList.add("addsticky");
                } else {
                    nav.classList.remove("addsticky");
                }
            }
            this.addSticky();
        });
    }
    hideReviewErrorsPopup = () => {
        this.setState({
            errors: [],
        });
    };
    render() {
        let activeIndex = 0;
        const item = this.props.options.enumOptions.filter((option, index) => {
            if (option.value === this.props.value) {
                activeIndex = index;
                return option;
            }
        });
        const activeMenu = item && item.length > 0 ? item[0] : this.props.options.enumOptions[0];
        const { id, isNavigable, clearNavigationStatus, userInfo } = this.props;
        const getimagePath = imagePathurl();
        // const { clearNavigationMenuStatus } = this.props.dynamicFormActions;
        return (
            <>
                {isNavigable && !isNavigable.navigable && isNavigable.message !== "" && (
                    <div className="alert-container">
                        <AlertMessage
                            type="error"
                            message={isNavigable.message}
                            closeAlert={clearNavigationStatus.clearNavigationMenuStatus}
                        />
                    </div>
                )}
                <div id={this.props.id} className="gaf-nav-menu">
                    <div className="mobile-menu">
                        <div
                            className={
                                userInfo && (userInfo.isAdmin || userInfo.isTm)
                                    ? "menu-accordion-admin"
                                    : "menu-accordion"
                            }
                        >
                            <div
                                className="accordion-header"
                                onClick={() => this.setState({ menuVisible: !this.state.menuVisible })}
                            >
                                <div className="accordion-index">{activeMenu && activeIndex + 1}</div>
                                <div className="accordion-label">{activeMenu && activeMenu["label"]}</div>
                                <div className="accordion-arrow-indicator">
                                    <img
                                        className="accordion-arrow"
                                        src={this.state.menuVisible ? `${getimagePath}chevron-up-thick-red.png` : `${getimagePath}chevron-down-thick-red.png`}
                                        alt="chevron-arrow"
                                    />
                                </div>
                            </div>
                            <div className="accordion-list">
                                {this.state.menuVisible
                                    ? this.props.options.enumOptions.map((option, index) => (
                                          <div
                                              id={`${id}-${index}`}
                                              key={`${this.props.id} ${index}`}
                                              className={`nav-menu-item ${
                                                  this.props.value === option.value ? "active" : ""
                                              }`}
                                              onClick={() => {
                                                  this.handleClick(option.value, `${this.props.id}-${index}`);
                                                  this.setState({ menuVisible: !this.state.menuVisible });
                                              }}
                                          >
                                              <div className="nav-index">
                                                  <span className="nav-index-value">{index + 1}</span>
                                                  {this.props.isDraft
                                                      ? this.navCounter(option.value) > 0 && (
                                                            <span className="badge-counter">
                                                                {this.navCounter(option.value)}
                                                            </span>
                                                        )
                                                      : this.navCounter(option.value) > 0 &&
                                                        this.state.menuKeys[index] &&
                                                        this.state.menuKeys[index].visitCount > 1 && (
                                                            <span className="badge-counter">
                                                                {this.navCounter(option.value)}
                                                            </span>
                                                        )}
                                                  {!this.props.isDraft &&
                                                      option.value === "PD" &&
                                                      this.state.showPDCount &&
                                                      this.navCounter(option.value) > 0 && (
                                                          <span className="badge-counter">
                                                              {this.navCounter(option.value)}
                                                          </span>
                                                      )}
                                              </div>
                                              <div className="nav-label">{option.label}</div>
                                              <div className="active-nav"></div>
                                          </div>
                                      ))
                                    : null}
                            </div>
                        </div>
                    </div>
                    <div className="desktop-menu">
                        {this.props.options.enumOptions.map((option, index) => (
                            <div
                                id={`${id}-${index}`}
                                key={`${this.props.id} ${index}`}
                                className={`nav-menu-item ${this.props.value === option.value ? "active" : ""}`}
                                onClick={() => this.handleClick(option.value, `${this.props.id}-${index}`)}
                                tabIndex={
                                    (this.props.schema.anyOf[index] &&
                                        this.props.schema.anyOf[index].const &&
                                        this.props.schema.anyOf[index].const.tabIndex) ||
                                    0
                                }
                                onKeyPress={handleEnter}
                            >
                                <div className="nav-index">
                                    <span className="nav-index-value">{index + 1}</span>
                                    {this.props.isDraft
                                        ? this.navCounter(option.value) > 0 && (
                                              <span className="badge-counter">{this.navCounter(option.value)}</span>
                                          )
                                        : this.navCounter(option.value) > 0 &&
                                          this.state.menuKeys[index] &&
                                          this.state.menuKeys[index].visitCount > 1 && (
                                              <span className="badge-counter">{this.navCounter(option.value)}</span>
                                          )}
                                    {!this.props.isDraft &&
                                        option.value === "PD" &&
                                        this.state.showPDCount &&
                                        this.navCounter(option.value) > 0 && (
                                            <span className="badge-counter">{this.navCounter(option.value)}</span>
                                        )}
                                </div>
                                <div className="nav-label">{option.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <GAFContact />
                {this.state.errors.length ? (
                    <ReviewErrorsPopup
                        hidePopsUp={this.hideReviewErrorsPopup}
                        goToErrors={this.goToError}
                        errors={this.state.errors}
                        errorDetails={this.props.errorDetails}
                    />
                ) : null}
            </>
        );
    }
}

export function mapStateToProps(state) {
    return {
        userInfo: state.adminData.userInfo,
        formId: state.dynamicFormInfo.formId,
        warrantyId: state.dynamicFormInfo.warrantyId,
        formData: state.dynamicFormInfo.warrantyInfo,
        isNavigable: state.dynamicFormInfo.navigation,
        warrentyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
        isSavedDraft: state.dynamicFormInfo.layoutResponse.isSavedDraft,
        uiSchema: state.dynamicFormInfo.layoutResponse.UISchema,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        menuKeys: state.dynamicFormInfo.menuKeys || [],
        isDraft: state.dynamicFormInfo.isDraft,
        saveMobileMsg: state.dynamicFormInfo.saveMobileMsg,
        saveDesktopMsg: state.dynamicFormInfo.saveDesktopMsg,
        paymentsInfo: state.payments,
        isSubmittedForm: state.adminData.isSubmittedForm,
        isApiCallInProcess: state.dynamicFormInfo.isApiCallInProcess,
        navMenus: state.dynamicFormInfo.navMenus,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        updateNavigationMenuStatus: bindActionCreators(dynamicFormActionCreators, dispatch),
        clearNavigationStatus: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalActions: bindActionCreators(globalActionsCreator, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(NavigationMenu);
